export default __webpack_public_path__ + "6fbd7fd572b14cdbaba40a1d7c56c5d2.png";